/**
 * Runtime theme helpers replacing the old MUI createTheme/themesFromPrimary.
 * The Tailwind preset reads these CSS variables (see tailwind.preset.cjs).
 */

export const PRIMARY_PURPLE = '#7f358c'

/** Parse a CSS hex color into space-separated RGB channels ("127 53 140"). */
export function hexToRgbChannels(hex: string): string | null {
  const normalized = hex.trim().replace(/^#/, '')
  const expanded =
    normalized.length === 3
      ? normalized
          .split('')
          .map((c) => c + c)
          .join('')
      : normalized
  if (!/^[0-9a-fA-F]{6}$/.test(expanded)) return null
  const num = parseInt(expanded, 16)
  return `${(num >> 16) & 255} ${(num >> 8) & 255} ${num & 255}`
}

/**
 * Inline style that scopes a custom primary color to an element's subtree
 * (per-soundboard colors — the old themesFromPrimary).
 */
export function primaryColorStyle(
  primary: string | undefined | null,
): Record<string, string> {
  const channels = primary && hexToRgbChannels(primary)
  return channels ? { '--ps-primary-rgb': channels } : {}
}

/** Set the app-wide primary color on the document root. */
export function setDocumentPrimaryColor(primary: string | undefined | null) {
  if (typeof document === 'undefined') return
  const channels = primary && hexToRgbChannels(primary)
  if (channels) {
    document.documentElement.style.setProperty('--ps-primary-rgb', channels)
  } else {
    document.documentElement.style.removeProperty('--ps-primary-rgb')
  }
}

/** Toggle Tailwind dark mode by stamping the `dark` class on <html>. */
export function setDocumentDarkMode(darkModeEnabled: boolean) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('dark', darkModeEnabled)
}
